import './TestOrderListTableComponent.scss';

import React from 'react';
import {ITableColumn} from "../../../../shared/models/table.model";
import {ITestOrder} from '../../../../shared/models/testOrder.model';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ChipComponent from "../../../../shared/components/chip/ChipComponent";
import {CommonService} from "../../../../shared/services";
import {Link} from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {APIConfig} from "../../../../constants";
import TableWrapperV2Component
    from "../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import TooltipComponent from "../../../../shared/components/tooltip/tooltipComponent";
import commonService from "../../../../shared/services/common.service";

interface TestOrderListTableComponentProps {
    filterData?: {};
    isColumnFilterVisible: boolean
}

const TestOrderListTableComponent = (props: TestOrderListTableComponentProps) => {

    const {filterData, isColumnFilterVisible} = props;
    const columns: ITableColumn[] = [
        {
            id: 'priorityIcon',
            label: '',
            isDefaultColumn: true,
            hideInColumnPreferences: true,
            width: '50',
            align: 'center',
            fixed: 'left',
            content: (item: ITestOrder, index: any) => (
                <React.Fragment>
                    {item?.isPriorityOrder && <ReportProblemIcon color={"primary"}/>}
                </React.Fragment>
            )

        },
        {
            id: 'code',
            label: 'Order ID',
            isDefaultColumn: true,
            fixed: 'left',
            width: '150',
            content: (item: ITestOrder) => (
                <div className="text-uppercase">
                    {item?.code || '-'}
                </div>
            )
        },
        {
            id: 'patient', label: 'Patient',
            isDefaultColumn: true,
            width: '200',
            content: (item: ITestOrder) => (
                <>
                    {
                        item?.patientDetails ? <>
                            {
                                (item?.patientDetails?.firstName + ' ' + item?.patientDetails?.lastName).length > 30 ?
                                    <TooltipComponent
                                        tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.firstName) + " " + CommonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.lastName)}
                                        placement={"top"}
                                        arrow={true}
                                    >
                                        <div className={"ellipses-for-table-data"}>
                                            {CommonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.firstName)} {CommonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.lastName)}
                                        </div>
                                    </TooltipComponent> :
                                    <>
                                        {CommonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.firstName)} {CommonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.lastName)}
                                    </>
                            }
                            <br/>
                            {
                                item?.patientDetails?.gender && <>
                                    (&nbsp;{item?.patientDetails?.gender[0]?.toUpperCase()}&nbsp;)&nbsp;
                                </>
                            }
                            {commonService.formatDate(item?.patientDetails.dateOfBirth)}
                        </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'facility', label: 'Facility', isDefaultColumn: false, align: 'center', width: '200',
            content: (item: ITestOrder) => (
                <React.Fragment>
                    {
                        item.facilityDetails ? <> {CommonService.capitalizeFirstLetterOfEachWord(item.facilityDetails.name)}
                        </> : <> - </>
                    }
                </React.Fragment>
            )
        },

        {
            id: 'location', label: 'Location', isDefaultColumn: false, align: 'center', width: '200',
            content: (item: ITestOrder) => (
                <React.Fragment>
                    {
                        item.locationDetails ? <> {item.locationDetails.name}
                        </> : <> - </>
                    }
                </React.Fragment>
            )
        },

        {
            id: 'orderingProvider', label: 'Provider',
            isDefaultColumn: true,
            content: (item: ITestOrder) => (
                <>
                    {
                        item?.physicianDetails ?
                            <>
                                {
                                    (item?.physicianDetails?.firstName + " " + item?.physicianDetails?.lastName + " " + item?.physicianDetails?.middleName).length > 30 ?
                                        <TooltipComponent
                                            tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.firstName) + " " + CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.middleName) + " " + CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.lastName)}
                                            arrow={true}
                                            placement={"top"}>
                                            <div className={"ellipses-for-table-data"}>
                                                Dr.{CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.firstName) || '-'} {item?.physicianDetails?.middleName} {CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.lastName)}
                                            </div>
                                        </TooltipComponent> :
                                        <>
                                            Dr. {CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.firstName) || '-'} {item?.physicianDetails?.middleName} {CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.lastName)}
                                            <br/>
                                        </>
                                }

                                NPI: {item?.physicianDetails?.npiNumber || '-'}
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'tests', label: 'Ordered Tests', align: 'center',
            isDefaultColumn: true,
            content: (item: ITestOrder) => {
                const tests = item?.tests.map((test:any) => {
                    return {title: test.code};
                });
                return <>
                    {
                        tests.length > 0 ?
                            <>
                                {
                                    tests?.map((test:any, index:number) => CommonService.capitalize(test.title)).join(', ').length > 10 ?
                                        <TooltipComponent
                                            tooltip={
                                                <div className={'pdd-right-15 pdd-top-5 pdd-bottom-5'}>
                                                    {tests?.map((test:any) => {
                                                            return <>{CommonService.capitalize(test.title)}<br/></>;
                                                        }
                                                    )}
                                                </div>}
                                            arrow={true}>
                                            <div className={'ellipses-for-table-data-tests'}>
                                                {tests?.map((test:any) => CommonService.capitalize(test.title)).join(', ')}
                                            </div>
                                        </TooltipComponent> :
                                        <>
                                            {tests?.map((test:any) => CommonService.capitalize(test.title)).join(', ')}
                                        </>
                                }
                            </> :
                            <> - </>
                    }
                </>
            }
        },
        {
            id: 'orderedDate', label: 'Ordered Date & Time', align: 'center',width:180,
            isDefaultColumn: true,
            content: (item: ITestOrder) => (
                <>
                    {
                        item?.createdAt ?
                            <>
                                {commonService.formatDate(item?.createdAt)}
                                &nbsp;|&nbsp;
                                {commonService.formatTime(item?.createdAt)} <br/>
                            </> :
                            <> - </>
                    }
                </>
            )
        },

        // {
        //     id: 'externalId', label: 'External ID', isDefaultColumn: false, align: 'center',
        //     content: (item: ITestOrder) => (
        //         <React.Fragment>
        //             {
        //                 item.externalPatientId ? <> item.externalPatientId
        //                 </> : <> - </>
        //             }
        //         </React.Fragment>
        //     )
        // },
        //
        // {
        //     id: 'billingMode', label: 'Billing Mode', isDefaultColumn: false, align: 'center',
        //     content: (item: ITestOrder) => (
        //         <React.Fragment>
        //             {
        //                 item.billingMode ? <> item.billingMode
        //                 </> : <> - </>
        //             }
        //         </React.Fragment>
        //     )
        // },

        {
            id: 'status',
            label: 'Test Order Status',
            isDefaultColumn: true,
            align: 'center',
            width: '150',
            content: (item: ITestOrder) => (
                <>
                    <ChipComponent className={`min-width-80 ${item?.statusObj?.code?.replace(' ','')}`}
                                   label={CommonService.capitalizeFirstLetter(item?.statusObj?.title)}
                                   variant={'outlined'}/>
                </>
            )
        },
        {
            id: 'actions',
            label: '',
            isDefaultColumn: true,
            hideInColumnPreferences: true,
            fixed: "right",
            width: "100",
            align: 'center',
            content: (item: ITestOrder, index: any) => (
                <React.Fragment>
                    <div className="table-actions" id={`view_testOrder_` + index}>
                        {item?.statusObj?.code === "draft" ? <>
                                <Link
                                    to={CommonService._routeConfig.TestOrderCreateRoute() + "?testOrderId=" + item?.id + "&step=test_order_details"}>
                                    <div className="table-action">
                                        <ChevronRightIcon/>
                                    </div>
                                </Link>
                            </> :
                            <Link to={CommonService._routeConfig.TestOrderDetailsRoute(item?.id)}>
                                <div className="table-action">
                                    <ChevronRightIcon/>
                                </div>
                            </Link>
                        }
                    </div>
                </React.Fragment>
            )
        },
    ];

    return (
        <div className="table-list-container">
            <TableWrapperV2Component
                isPaginated={true}
                isHoverable={true}
                isColumnFilterVisible={isColumnFilterVisible}
                columns={columns}
                url={APIConfig.TEST_ORDER_LIST.URL}
                method={APIConfig.TEST_ORDER_LIST.METHOD}
                extraPayload={filterData}
            />
        </div>
    )
}
export default TestOrderListTableComponent;
